import React, { useEffect, useCallback, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getDetailCommandeSage, getCommandeByIdSage, historiqueCommande } from "../../Redux/commandeReduce";
import ImprimerCmd from "./ImprimerCmd";
import Configuration from "../../configuration";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function DetailsCmdSage({ obj }) {
  const dispatch = useDispatch();
  const location = useParams();
  var idCmd = location.id;
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const [produitExist, setProduitExist] = React.useState([]);

  //input
  const [fileURL, setFileURL] = React.useState(null);
  const [fileName, setFileName] = React.useState("null");
  const [ext, setExt] = React.useState("");
  const [data, setData] = React.useState([]);
  const [cmd, setCmd] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  /* detailCmd */
  const detailCmd = useCallback(async (idCmd) => {
    var det = await dispatch(getDetailCommandeSage(idCmd));
    var dataD = await det.payload;
    setData(dataD)
    var dataCmd = await dispatch(getCommandeByIdSage(idCmd));
    var cmdD = await dataCmd.payload;
    setCmd(cmdD);

    setLoader(false);
  }, [dispatch, idCmd]);


  useEffect(() => {
    detailCmd(idCmd)
  }, [idCmd, id]);

  const exportToExcel = async () => {
    if (data.length === 0) {
      toast.warning(t("no_data_to_export"));
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Order Details");

    // Add headers
    worksheet.columns = [
      { header: t("num_order"), key: "numero", width: 15 },
      { header: "Grossiste", key: "grossiste", width: 15 },
      { header: "Date commande", key: "date_commande", width: 15 },
      { header: "Code Article", key: "Code_article", width: 15 },
      { header: "Produit", key: "Designation_1", width: 25 },
      { header: "Quantité", key: "quantite", width: 10 },
      { header: "Prix_commande UN HT", key: "prix", width: 10 },
      { header: "Total HT", key: "montant", width: 10 },
    ];

    // Add rows
    data.forEach((e) => {
      worksheet.addRow({
        Code_article: e.CodeArticle,
        numero: e.NumCommande,
        date_commande: e.DateCommande,
        grossiste: cmd.CodeClient,
        Designation_1: e.DesignationArticle,
        quantite: e.QuantiteNonSoldee,
        prix: e.Prix_commande ? parseFloat(e.Prix_commande).toFixed(3) : "0.000",
        montant: parseFloat(e.QuantiteNonSoldee * e.Prix_commande) ? parseFloat(e.QuantiteNonSoldee * e.Prix_commande).toFixed(3) : "0.000",
      });
    });

    // Add styling (optional)
    worksheet.getRow(1).font = { bold: true };

    // Generate and save file
    const buffer = await workbook.xlsx.writeBuffer();
    const fileName = `Order_Details_${idCmd}.xlsx`;
    saveAs(new Blob([buffer]), fileName);

    toast.success("Exporté avec succès");
  };


  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{t("order_details")}</Card.Title>
                    </Card.Header>
                    <Card.Body>

                      <div>
                        {obj.user.id_role != 6 && data.length > 0 && (
                          <Button
                            className="btn-wd  btn mr-1 float-right btn-export"

                            onClick={exportToExcel}
                          >
                            <span className="btn-label">
                              <i className="fas fa-file-excel"></i>
                            </span>
                            Export Excel
                          </Button>
                        )}
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("num_order")}</th>
                              <th>Code Grossiste</th>
                              <th>Grossiste</th>
                              <th>Date {t("commande")}</th>
                              <th>{cmd.etat != 2 ? t("date_liv_souhaite") : t("date_liv")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{cmd.NumCommande}</td>
                              <td>{cmd.Client}</td>
                              <td>{cmd.RaisonSocial}</td>
                              <td>{cmd.DateCommande}</td>
                              <td>{cmd.DateLivraison}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr>
                        <h4><strong>{t('montant_total')}:  {new Intl.NumberFormat('fr-FR', {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3
                        }).format(parseFloat(cmd.MontantHT_TND))} HT TND</strong></h4>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("code_article")}</th>
                              <th>{t("product")}</th>
                              <th>{t("qte")}</th>
                              <th>{t("prix")} HT</th>
                              <th>{t("total")} </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((e) => {
                              return (
                                <tr key={"ligne-" + e.CodeArticle} >
                                  <td>{e.CodeArticle}</td>
                                  <td>{e.DesignationArticle}</td>
                                  <td>{e.QuantiteTotale}</td>
                                  <td>{e.Prix_commande ? new Intl.NumberFormat('fr-FR', {
                                    minimumFractionDigits: 3,
                                    maximumFractionDigits: 3
                                  }).format(parseFloat(e.Prix_commande)) : "0.000"}</td>
                                  <td>{parseFloat(e.QuantiteNonSoldee * e.Prix_commande) ? new Intl.NumberFormat('fr-FR', {
                                    minimumFractionDigits: 3,
                                    maximumFractionDigits: 3
                                  }).format(parseFloat(e.QuantiteNonSoldee * e.Prix_commande)) : "0.000"}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsCmdSage;
